import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '日韩影视的中文字幕从哪里获取？',
    answer: '日韩影视的中文字幕通常由各大字幕组（如日剧字幕组、韩剧字幕联盟、RM字幕组等）志愿翻译制作。您可以在本站各分类页面中找到我们整理的字幕资源导航，直接跳转到对应字幕组的发布页面获取字幕文件。',
  },
  {
    question: '下载的字幕文件如何加载到视频中？',
    answer: '大部分播放器都支持字幕加载。以PotPlayer为例：将字幕文件（通常为.srt或.ass格式）与视频文件放在同一文件夹中并保持同名，打开视频即可自动加载。如需手动加载，右键点击播放画面 → 字幕 → 加载字幕 → 选择文件即可。详细教程请查看本站"使用教程"分类。',
  },
  {
    question: '字幕文件的常见格式有哪些？',
    answer: '最常见的字幕格式是SRT（SubRip Text），几乎所有播放器都支持。此外还有ASS/SSA（Advanced SubStation Alpha，支持更丰富的样式效果）、VTT（WebVTT，网页播放常用）等格式。本站推荐的资源以SRT格式为主，兼容性最好。',
  },
  {
    question: '字幕更新频率如何？能跟上剧集播出进度吗？',
    answer: '对于热门日韩剧集，字幕组通常在剧集播出后24-48小时内完成中文字幕翻译。电影和综艺节目的字幕更新周期稍长，一般在3-7天左右。本站会实时跟踪最新字幕发布情况，确保您能第一时间获取资源。',
  },
  {
    question: '为什么有时字幕与视频不同步？',
    answer: '字幕不同步通常是因为字幕文件是为不同版本的视频源制作的（如不同帧率或片源版本）。解决方法：1）使用播放器快捷键实时微调（PotPlayer按"["和"]"）；2）使用Subtitle Edit等工具批量调整时间轴；3）在本站搜索与您视频版本匹配的字幕资源。',
  },
  {
    question: '中文字幕 日韩平台是否收费？',
    answer: '本站是一个完全免费的日韩影视中文字幕资源导航平台。我们不制作字幕，而是整理、汇总各大字幕组的优质资源，并提供使用指南。所有字幕资源均由志愿字幕组免费提供，我们只是帮您更便捷地找到它们。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">关于日韩影视中文字幕的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-2xl bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200 text-foreground-600 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}